import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';

import { eliminarSolicitudWA } from '../../actions/solicitudes_wa';

const EliminarSolicitudWA = ({ solicitud, reestablecerSolicitud }) => {

    const dispatch = useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [solicitudData, setSolicitudData] = useState({
        id: null,
        wa_id: null,
        nombre_wa: null
    });

    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarSolicitudWA(solicitudData.id));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if (!statusProcesar) {
            setSolicitudData({ id: null, wa_id: null, nombre_wa: null });
            reestablecerSolicitud(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if (solicitud) {
            setSolicitudData({
                id: solicitud._id,
                wa_id: solicitud.wa_id,
                nombre_wa: solicitud.nombre_wa
            });
            setEliminarModal(true);
        }
    }, [solicitud]);

    return (
        <Modal size="md" show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar solicitud</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    ¿Deseas eliminar la solicitud de{' '}
                    <strong>{solicitudData.nombre_wa || solicitudData.wa_id || 'este número'}</strong>?
                </p>
                <p className="text-muted" style={{ fontSize: '0.85rem' }}>Esta acción no se puede deshacer.</p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => handleCerrar()}
                    disabled={statusProcesar}
                >
                    <i className="fas fa-times fa-sm"></i> No
                </button>
                {
                    statusProcesar
                        ? <button type="button" className="btn btn-danger" disabled>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Sí, eliminar
                          </button>
                        : <button type="button" className="btn btn-danger" onClick={() => handleProcesar()}>
                            <i className="fas fa-trash fa-sm"></i> Sí, eliminar
                          </button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarSolicitudWA;
